@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-process-definitions-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [processDefinition]="_context.formContext.item"
                (processDefinitionUpdated)="onProcessDefinitionUpdated($event)"
                (canceled)="onCanceled($event)"></app-process-definitions-form>
        </mat-tab>
    </mat-tab-group>
}
